const LAST_SCREEN_KEY = 'nordia_dashboard_last_screen';
const PREV_SCREEN_KEY = 'nordia_dashboard_prev_screen';

export function saveCurrentScreen(path) {
  if (typeof window === 'undefined' || typeof sessionStorage === 'undefined' || !path) return;
  try {
    const current = sessionStorage.getItem(LAST_SCREEN_KEY);
    if (current && current !== path) {
      sessionStorage.setItem(PREV_SCREEN_KEY, current);
    }
    sessionStorage.setItem(LAST_SCREEN_KEY, path);
  } catch (e) {
    // Ignore storage issues
  }
}

export function getLastScreen(fallback = '/') {
  if (typeof window === 'undefined' || typeof sessionStorage === 'undefined') return fallback;
  try {
    const last = sessionStorage.getItem(LAST_SCREEN_KEY);
    return last || fallback;
  } catch (e) {
    return fallback;
  }
}

export function getPreviousScreen(fallback = '/') {
  if (typeof window === 'undefined' || typeof sessionStorage === 'undefined') return fallback;
  try {
    const prev = sessionStorage.getItem(PREV_SCREEN_KEY);
    return prev || fallback;
  } catch (e) {
    return fallback;
  }
}
